import React from 'react';
import SearchBox from '../SearchBox/SearchBox';
import './SearchForm.scss';
import AdditionalFilter from '../AdditionalFilter/AdditionalFilter';
import CameraInformation from '../CameraInformation/CameraInformation';

export default ({ onSave }) => {
  return (
    <div className="search-form">
      <SearchBox 
        onSave={onSave}
      />
      <CameraInformation />
      <AdditionalFilter />
    </div>
  )
}